/* COUNTDOWN TIMER - PixelUnik */
(function() {
  'use strict';

  const CONFIG = {
    wrapperSelector: '.pct-wrapper',
    storagePrefix: 'pct_countdown_',
    defaultHours: 24
  };

  function init() {
    const wrappers = document.querySelectorAll(CONFIG.wrapperSelector);
    wrappers.forEach(wrapper => initCountdown(wrapper));
  }

  function initCountdown(wrapper) {
    const productId = wrapper.dataset.productId;
    const hours = parseInt(wrapper.dataset.hours) || CONFIG.defaultHours;
    const minutes = parseInt(wrapper.dataset.minutes) || 0;
    const urgentThreshold = parseInt(wrapper.dataset.urgentThreshold) || 2;
    
    const endTime = getEndTime(productId, hours, minutes);
    if (!endTime) return;

    wrapper.style.display = 'block';
    
    updateCountdown(wrapper, endTime, urgentThreshold, productId);
    setInterval(() => updateCountdown(wrapper, endTime, urgentThreshold, productId), 1000);
  }

  function getEndTime(productId, hours, minutes) {
    const key = CONFIG.storagePrefix + productId;
    const duration = (hours * 60 * 60 + minutes * 60) * 1000;
    const stored = localStorage.getItem(key);
    
    if (stored) {
      const endTime = parseInt(stored);
      if (endTime > Date.now()) return endTime;
      localStorage.removeItem(key);
    }
    
    const endTime = Date.now() + duration;
    localStorage.setItem(key, endTime.toString());
    return endTime;
  }

  function updateCountdown(wrapper, endTime, urgentThreshold, productId) {
    const remaining = endTime - Date.now();
    
    if (remaining <= 0) {
      wrapper.style.display = 'none';
      localStorage.removeItem(CONFIG.storagePrefix + productId);
      return;
    }

    const hours = Math.floor((remaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

    updateDisplay(wrapper, 'hours', hours);
    updateDisplay(wrapper, 'minutes', minutes);
    updateDisplay(wrapper, 'seconds', seconds);

    const totalHours = remaining / (1000 * 60 * 60);
    wrapper.classList.toggle('urgent', totalHours <= urgentThreshold);
  }

  function updateDisplay(wrapper, unit, value) {
    const el = wrapper.querySelector('[data-unit="' + unit + '"] .pct-value');
    if (el) {
      const padded = value.toString().padStart(2, '0');
      if (el.textContent !== padded) {
        el.classList.add('changing');
        el.textContent = padded;
        setTimeout(() => el.classList.remove('changing'), 300);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();